/* ============================================================================
   LAH — RETOMAR O CONFIGURADOR DE ONDE PAROU
   Tema: Testes de implementacao (1.0)

   Guarda o que o cliente escolheu no configurador e oferece continuar de onde
   parou. Este arquivo cuida da pagina do produto; o aviso que sobe nas demais
   paginas vive em lah-retomar-toast.js e le o mesmo registro.

   ============================================================================
   SO QUEM CHEGOU AO RESUMO E LEMBRADO
   ============================================================================
   Antes, qualquer escolha guardada gerava o lembrete — inclusive de quem clicou
   numa opcao, mudou de ideia em dois segundos e saiu. Esse cliente nao
   abandonou nada: ele olhou. Oferecer que ele "continue" uma montagem que nunca
   comecou de verdade e insistencia, nao ajuda.

   Quem chega ao RESUMO percorreu o fluxo inteiro: escolheu lente, tratamento e
   campo de visao, e viu o preco final. Saindo dali, saiu de uma decisao — e e
   essa pessoa que vale a pena trazer de volta.

   Como detectamos: o bloco de preco do rodape (.product-lens-footer-price) so
   fica visivel na etapa de resumo. E o mesmo sinal que o Envio Turbo usa para
   saber que o clique de "Adicionar ao carrinho" partiu dali.

   A marca e DEFINITIVA: uma vez no resumo, o registro fica elegivel mesmo que
   o cliente volte etapas depois. Ele ja viu o conjunto; voltar para ajustar
   nao desfaz isso.

   ============================================================================
   PRIORIDADE: A RECOMPRA VENCE
   ============================================================================
   Cliente logado com pedido anterior ve o botao de REPETIR AS LENTES DA ULTIMA
   COMPRA. Havendo os dois, o lembrete se cala: a recompra e o atalho melhor —
   esse cliente ja conhece o fluxo e resolve em um clique.

   A checagem olha o BLOCO DE DADOS, nao o botao: o botao e criado por
   lah-repeat.js, que carrega depois deste arquivo.

   ============================================================================
   O QUE E GUARDADO
   ============================================================================
   A etapa e o nome da opcao, mais nome, endereco e imagem do produto — estes
   tres para o aviso global saber de qual oculos se trata. Nada de preco, dados
   pessoais ou receita.

   Nao guardamos os IDs dos itens: o configurador os gera com um numero
   aleatorio a cada renderizacao.

   VALIDADE DE 7 DIAS: alem disso, preco ou catalogo podem ter mudado.
   ============================================================================ */

(function () {
    'use strict';

    var VALIDADE_DIAS = 7;

    var raiz = document.querySelector('.product-lens-select');
    var cta = document.querySelector('.openProductLens');
    if (!raiz || !cta) return;

    var bloco = document.querySelector('[data-lah-retomar]');
    if (!bloco) return;

    var temRecompra = !!document.querySelector('[data-lah-repeat]');

    /* O snippet e renderizado no fim do <body> — o Liquid nao alcanca o ponto
       acima do CTA sem editar product-lens-select.liquid. Movemos aqui. */
    cta.parentNode.insertBefore(bloco, cta);

    var PRODUTO = {
        id: bloco.getAttribute('data-produto-id') || '',
        nome: bloco.getAttribute('data-produto-nome') || '',
        url: bloco.getAttribute('data-produto-url') || '',
        img: bloco.getAttribute('data-produto-img') || ''
    };

    var CHAVE = 'lah_config_' + PRODUTO.id;

    function track(evento, dados) {
        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(Object.assign({ event: evento }, dados || {}));
        } catch (e) { /* analytics nunca deve quebrar a venda */ }
    }

    function ler() {
        try {
            var bruto = window.localStorage.getItem(CHAVE);
            return bruto ? JSON.parse(bruto) : null;
        } catch (e) {
            return null;
        }
    }

    function gravar(dados) {
        try {
            window.localStorage.setItem(CHAVE, JSON.stringify(dados));
        } catch (e) { /* modo privado: o fluxo segue, so nao lembra */ }
    }

    function apagar() {
        try {
            window.localStorage.removeItem(CHAVE);
        } catch (e) { /* ignora */ }
    }

    /* =====================================================================
       SALVAR
       ===================================================================== */
    function estadoAtual() {
        var escolhas = [];

        Array.prototype.forEach.call(
            raiz.querySelectorAll('.product-lens-select-item.selected'),
            function (item) {
                var etapa = item.closest('.product-lens-select-step');
                if (!etapa) return;

                escolhas.push({
                    etapa: etapa.getAttribute('data-step-selector') || '',
                    item: item.getAttribute('data-item-name') || ''
                });
            }
        );

        return escolhas;
    }

    function etapaVisivel() {
        var etapas = raiz.querySelectorAll('.product-lens-select-step');

        for (var i = 0; i < etapas.length; i++) {
            if (etapas[i].offsetParent !== null) {
                var t = etapas[i].querySelector('.product-lens-step-title');
                return t ? t.textContent.trim() : '';
            }
        }

        return '';
    }

    /* O bloco de preco do rodape so aparece no resumo — ver a nota no topo. */
    function noResumo() {
        var preco = document.querySelector('.product-lens-footer-price');
        return !!(preco && preco.offsetParent !== null);
    }

    function salvar() {
        var escolhas = estadoAtual();
        if (!escolhas.length) return;

        var anterior = ler();
        var jaChegou = !!(anterior && anterior.resumo);

        gravar({
            escolhas: escolhas,
            etapa: etapaVisivel(),
            /* Uma vez verdadeiro, permanece: voltar etapas depois de ver o
               resumo nao desfaz o fato de ter visto. */
            resumo: jaChegou || noResumo(),
            produto: PRODUTO,
            em: Date.now()
        });
    }

    /* Cada escolha atualiza o que esta guardado. Em captura e sem bloquear:
       so observamos. O rAF espera o Alpine repintar antes de lermos. */
    document.addEventListener('click', function (event) {
        if (!event.target.closest) return;
        if (!event.target.closest('.product-lens-select-item')) return;

        requestAnimationFrame(function () {
            setTimeout(salvar, 80);
        });
    }, true);

    /* Avancar de etapa tambem precisa ser observado: o cliente pode chegar ao
       resumo pelo botao "Avancar", sem clicar em mais nenhuma opcao — e nesse
       caso o clique acima nunca dispararia. */
    document.addEventListener('click', function (event) {
        if (!event.target.closest) return;
        if (!event.target.closest('.lens-footer-button')) return;

        requestAnimationFrame(function () {
            setTimeout(salvar, 120);
        });
    }, true);

    /* Adicionou ao carrinho: a configuracao virou pedido e nao ha mais o que
       retomar. */
    document.addEventListener('click', function (event) {
        if (!event.target.closest) return;

        var botao = event.target.closest('.lens-footer-button');
        if (!botao) return;

        if (noResumo()) {
            apagar();
            esconder();
        }
    });

    /* =====================================================================
       RESTAURAR
       ===================================================================== */
    function acharEtapa(seletor) {
        var etapas = raiz.querySelectorAll('.product-lens-select-step');

        for (var i = 0; i < etapas.length; i++) {
            if ((etapas[i].getAttribute('data-step-selector') || '') === seletor) {
                return etapas[i];
            }
        }

        return null;
    }

    function acharOpcao(etapa, nome) {
        if (!etapa) return null;

        var itens = etapa.querySelectorAll('.product-lens-select-item');

        for (var i = 0; i < itens.length; i++) {
            if ((itens[i].getAttribute('data-item-name') || '') === nome) {
                return itens[i];
            }
        }

        return null;
    }

    /* Uma etapa por vez, esperando a seguinte aparecer. Tentativas limitadas:
       se algo mudou no catalogo e a opcao nao existe mais, paramos em silencio
       e o cliente segue escolhendo com a mao — nunca travamos. */
    function reproduzir(lista, indice) {
        if (indice >= lista.length) return;

        var passo = lista[indice];
        var tentativas = 0;

        (function tentar() {
            var etapa = acharEtapa(passo.etapa);
            var opcao = acharOpcao(etapa, passo.item);
            var visivel = etapa && etapa.offsetParent !== null;

            if (opcao && visivel) {
                opcao.click();
                requestAnimationFrame(function () {
                    setTimeout(function () { reproduzir(lista, indice + 1); }, 90);
                });
                return;
            }

            tentativas++;
            if (tentativas > 40) return;

            setTimeout(tentar, 60);
        })();
    }

    function retomar(dados) {
        track('lens_retomado', {
            origem: 'produto',
            etapas: dados.escolhas.length,
            etapa_parada: dados.etapa || ''
        });

        esconder();
        cta.click();

        setTimeout(function () {
            reproduzir(dados.escolhas, 0);
        }, 260);
    }

    /* =====================================================================
       O LEMBRETE
       ===================================================================== */
    function esconder() {
        bloco.hidden = true;
    }

    function mostrar(dados) {
        var detalhe = bloco.querySelector('[data-retomar-detalhe]');

        if (detalhe) {
            var nomes = dados.escolhas.map(function (e) { return e.item; }).join(' · ');
            detalhe.textContent = dados.etapa
                ? 'Você parou em: ' + dados.etapa
                : nomes;
            detalhe.title = nomes;
        }

        bloco.hidden = false;
        track('lens_retomar_exibido', { origem: 'produto', etapas: dados.escolhas.length });
    }

    bloco.addEventListener('click', function (event) {
        if (event.target.closest('[data-retomar-continuar]')) {
            var dados = ler();
            if (dados) retomar(dados);
            return;
        }

        if (event.target.closest('[data-retomar-descartar]')) {
            track('lens_retomar_descartado', { origem: 'produto' });
            apagar();
            esconder();
        }
    });

    /* =====================================================================
       INICIO
       ===================================================================== */
    var guardado = ler();

    if (guardado && guardado.escolhas && guardado.escolhas.length) {
        var idade = Date.now() - (guardado.em || 0);
        var limite = VALIDADE_DIAS * 24 * 60 * 60 * 1000;

        if (idade > limite) {
            apagar();
        } else if (!guardado.resumo) {
            /* Nao chegou ao resumo: olhou, nao decidiu — ver a nota no topo. */
            track('lens_retomar_suprimido', { motivo: 'sem_resumo' });
        } else if (temRecompra) {
            track('lens_retomar_suprimido', { motivo: 'recompra' });
        } else {
            mostrar(guardado);
        }
    }
})();
